import React from "react";

import technox from "../assets/images/client/technox.svg";
import nitdata from "../assets/images/client/nitdata.png";
import "../assets/css/Portfolio.css";

const Portfolio = () => {
  return (
    <section className="bg-overlay  ts-chart">
      <div className="container">
        <h4 className="text-center title-white">
          Our Portfolio
        </h4>

        <p className="text-center intro-desc">
          Success is rarely a straight path. For us that means the real work
          begins after the investment. We contribute an unparalleled set of
          skills, experience, and a great deal of time and attention to our
          group companies nurtured in every step.
        </p>

        <div className="pt-3 text-center row">
          {/* Logo 1 */}
          <div className="col-md-6 col-12 mb-4">
            <img
              src={technox}
              alt="technox"
              className="w-50"
            />
          </div>

          {/* Logo 2 */}
          <div className="col-md-6 col-12 mb-4">
            <img
              src={nitdata}
              alt="nitdata"
              className="w-50"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;